import { marked, RendererObject } from 'marked';
import { isEmpty } from '@cutwise/utils';

const renderer: RendererObject = {
  link({ href, text, tokens }) {
    const linkText = tokens && this.parser ? this.parser.parseInline(tokens) : text;

    return `<a target="_blank" href="${href}">${linkText}</a>`;
  },
};

marked.use({ renderer });

export function formatMarkdown(text: string) {
  // if for some reason empty value is passed
  if (typeof text !== 'string') {
    return text;
  }

  // for empty string
  if (isEmpty(text)) {
    return text;
  }

  const result = marked.parse(text) as string;

  // remove blank line breaks in the end
  return result.trim();
}
